import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/telesky/src/app/services/components/ServicesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/telesky/src/components/common/Header.tsx");
